import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=02f76212"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports